"use strict";

// "use strict";

jQuery(document).ready(function ($) {
  // Initialize portfolio load more for all-portfolio-block instances
  function initPortfolioBlock($block) {
    var $container = $block.find('.portfolio-container');
    var $dropdown = $block.find('.post-filters__dropdown');
    var blockId = $container.data('block-id');
    if (!$container.length) {
      return;
    }

    // Get data attributes from container
    var postsPerPage = parseInt($container.attr('data-posts-per-page')) || 6;
    var maxNumPages = parseInt($container.attr('data-max-num-pages')) || 1;
    var orderBy = $container.attr('data-order-by') || 'menu_order';
    var order = $container.attr('data-order') || 'ASC';
    var filterCategory = $container.attr('data-filter-category') || 'all';

    // Create unique variable names for this block instance
    var varPrefix = 'portfolio_' + blockId.replace(/[^a-zA-Z0-9]/g, '_');

    // Set global variables for this block (using unique names)
    window[varPrefix + '_postsPerPage'] = postsPerPage;
    window[varPrefix + '_maxNumPages'] = maxNumPages;
    window[varPrefix + '_orderBy'] = orderBy;
    window[varPrefix + '_order'] = order;
    window[varPrefix + '_filterCategory'] = filterCategory;

    // Store reference to current block's variables
    var currentVars = {
      postsPerPage: window[varPrefix + '_postsPerPage'],
      maxNumPages: window[varPrefix + '_maxNumPages'],
      orderBy: window[varPrefix + '_orderBy'],
      order: window[varPrefix + '_order'],
      filterCategory: window[varPrefix + '_filterCategory']
    };

    // Initialize load more functionality using existing class but with block-specific variables
    var canBeLoaded = true;
    var currentPage = 1;
    // Sync catSlug with dropdown value if dropdown exists, otherwise use filterCategory from data attribute
    var catSlug = $dropdown.length && $dropdown.val() ? $dropdown.val() : filterCategory;

    // Function to load posts via AJAX
    function loadThePosts() {
      if (currentPage > currentVars.maxNumPages) {
        return false;
      }
      var loadingIconPath = typeof ajax_resources !== 'undefined' ? "".concat(ajax_resources.theme_path, "/assets/images/icons/loading.gif") : '';
      var loadingIcon = loadingIconPath ? "<img class='ajax-loading-icon' src='".concat(loadingIconPath, "' alt='loading-icon'>") : '';
      $.ajax({
        url: typeof ajax_resources !== 'undefined' ? ajax_resources.ajaxurl : '/wp-admin/admin-ajax.php',
        type: 'post',
        data: {
          action: 'load_more_portfolio',
          'cat_slug': catSlug,
          'page': currentPage,
          'posts_per_page': currentVars.postsPerPage,
          'orderby': currentVars.orderBy,
          'order': currentVars.order,
          'filterCategory': catSlug
        },
        beforeSend: function beforeSend(xhr) {
          if (currentPage <= currentVars.maxNumPages) {
            $container.append(loadingIcon);
          }
          canBeLoaded = false;
        },
        success: function success(result) {
          if (result) {
            if (currentPage === 1) {
              // If category is changed or reset, and the page is back to 1
              $container.find('.project-excerpt').remove();
            }
            $container.append(result);
            canBeLoaded = true;

            // Trigger animations if function exists
            if (typeof triggerAnimation === 'function') {
              triggerAnimation();
            }
          }
          $container.find('.ajax-loading-icon').remove();
        },
        error: function error(xhr, status, _error) {
          $container.find('.ajax-loading-icon').remove();
          canBeLoaded = true;
        }
      });
    }

    // Scroll handler for infinite scroll
    $(window).on('scroll.portfolio-block-' + blockId, function () {
      var bottomOfPosts = $container.offset().top + $container.outerHeight();
      var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
      if (bottomOfScreen > bottomOfPosts - 400 && canBeLoaded === true && currentPage < currentVars.maxNumPages) {
        currentPage++;
        loadThePosts();
      }
    });

    // Sub-filter container and handlers
    var $subFiltersContainer = $block.find('[id^="post-sub-filters-"]');

    // Function to show/hide sub-filters based on dropdown selection
    function updateSubFilters() {
      if (!$dropdown.length || !$subFiltersContainer.length) {
        return;
      }
      var selectedId = $dropdown.find('option:selected').attr('data-id');
      var $subFilters = $subFiltersContainer.find('.post-sub-filters__list');

      // Hide all sub-filters first
      $subFilters.hide();

      // Show sub-filters for selected parent category
      if (selectedId && selectedId !== 'all') {
        // Convert to string for consistent comparison
        var selectedIdStr = String(selectedId);
        var $matchingSubFilters = $subFilters.filter(function () {
          return String($(this).attr('data-value')) === selectedIdStr;
        });
        if ($matchingSubFilters.length > 0) {
          $matchingSubFilters.css('display', 'flex');
        }
      }
    }

    // Sub-filter click handler
    if ($subFiltersContainer.length) {
      $subFiltersContainer.find('a').on('click.portfolio-block-' + blockId, function (e) {
        e.preventDefault();
        currentPage = 1;
        $subFiltersContainer.find('a').removeClass('active');
        $(this).addClass('active');
        currentVars.maxNumPages = parseInt($(this).attr('data-max-page')) || 1;
        var subCategory = $(this).attr('data-slug');

        // Update variables
        catSlug = subCategory;
        currentVars.filterCategory = subCategory;

        // Update container data attributes
        $container.attr('data-filter-categories', subCategory);
        $container.attr('data-filter-category', subCategory);
        $container.attr('data-max-num-pages', currentVars.maxNumPages);
        loadThePosts();
      });
    }

    // Dropdown change handler - handles both post loading and sub-filter visibility
    if ($dropdown.length) {
      // Get initial dropdown value - ensure it defaults to "all"
      var initialValue = $dropdown.val();

      // Force to "all" if not set or empty (matching portfolio.php behavior)
      if (!initialValue || initialValue === '' || initialValue === null || initialValue === undefined) {
        $dropdown.val('all');
        initialValue = 'all';
      }

      // Initialize variables based on initial selection
      catSlug = initialValue;
      currentVars.filterCategory = initialValue;

      // Get max pages from the selected option
      var selectedOption = $dropdown.find('option:selected');
      if (selectedOption.length) {
        currentVars.maxNumPages = parseInt(selectedOption.attr('data-max-page')) || maxNumPages;
      } else {
        // Fallback to "all" option if nothing selected
        var allOption = $dropdown.find('option[value="all"]');
        if (allOption.length) {
          currentVars.maxNumPages = parseInt(allOption.attr('data-max-page')) || maxNumPages;
          $dropdown.val('all');
          catSlug = 'all';
          currentVars.filterCategory = 'all';
        }
      }

      // Update container data attributes
      $container.attr('data-max-num-pages', currentVars.maxNumPages);
      $container.attr('data-filter-category', catSlug);

      // Hide/show sub-filters based on initial selection
      if ($subFiltersContainer.length) {
        var $subFilters = $subFiltersContainer.find('.post-sub-filters__list');
        if (initialValue === 'all') {
          // Hide all sub-filters when "all" is selected
          $subFilters.hide();
        } else {
          // Show sub-filters for the selected parent category
          updateSubFilters();
        }
      }

      // Dropdown change handler (matching loadMorePosts behavior)
      $dropdown.on('change.portfolio-block-' + blockId, function () {
        currentPage = 1;
        var selectedValue = $(this).val();
        var selectedOption = $(this).find('option:selected');

        // Update category slug - this will filter to parent category (includes children)
        catSlug = selectedValue;
        currentVars.filterCategory = selectedValue;

        // Get max pages from the selected option (matching loadMorePosts line 139)
        currentVars.maxNumPages = parseInt(selectedOption.attr('data-max-page')) || 1;

        // Remove active class from all sub-filter links when changing main filter
        if ($subFiltersContainer.length) {
          $subFiltersContainer.find('a').removeClass('active');
        }

        // Update container data attributes
        $container.attr('data-max-num-pages', currentVars.maxNumPages);
        $container.attr('data-filter-category', catSlug);

        // Update sub-filter visibility
        // If "all" selected, hide sub-filters. Otherwise show sub-filters for selected parent
        updateSubFilters();

        // Load posts with the selected category (matching loadMorePosts line 141)
        // If "all" - no filtering, shows all posts
        // If parent category - shows all posts in that parent (including children)
        loadThePosts();
      });
    }
  }

  // Initialize all portfolio blocks on the page
  $('.all-portfolio-block').each(function () {
    initPortfolioBlock($(this));
  });
});